<template>
  <v-dialog :value="filterForm.modalType === 'status'" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển mối quan hệ
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển mối quan hệ"
              >
                <v-autocomplete
                  v-model="statusId"
                  :items="contactStatusList"
                  item-text="otherName"
                  item-value="id"
                  label="Mối quan hệ"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="12">
              <v-menu
                  ref="segmentMenu"
                  v-model="segmentMenu"
                  :close-on-content-click="false"
                  :return-value.sync="segmentCode"
                  transition="scale-transition"
                  offset-y
                  min-width="937px"
                  max-width="937px"

              >
                <template v-slot:activator="{ on, attrs  }">
                  <div v-on="on"
                       v-bind="attrs">
                    <validation-provider name="Tệp khách hàng">
                      <v-select
                          :items="listSegment"
                          item-value="id"
                          item-text="segmentCode"
                          readonly
                          hide-details
                          persistent-hint
                          label="Tệp khách hàng"
                          v-model="segmentId"
                          chips
                          :menu-props="{ bottom: true, maxHeight: 250 }"
                      >
                        <template v-slot:selection="{ item }">
                          <v-chip close
                                  text-color="#FFF"
                                  color="#FF6609"
                                  @click:close="handleDeleteSegment"
                          >
                            {{ item.segmentCode }}
                          </v-chip>
                        </template>
                      </v-select>
                    </validation-provider>
                  </div>
                </template>
                <div v-if="segmentId === ''" style="background: white; max-height: 400px; overflow: auto; padding: 0 12px 12px 12px">

                  <v-text-field
                      dense
                      ref="search"
                      v-model="searchInput"
                      full-width
                      hide-details
                      placeholder="Tìm kiêm tệp khách hàng"
                      single-line
                  />
                  <div>
                    <v-chip-group style="margin-top: 7px;" v-model="segmentId" column>
                      <template v-for="segment in categoriesSegment">
                        <v-chip @click="segmentMenu = false" :value="segment.id" text-color="#FFF" color="#FF6609">{{ segment.segmentCode }}</v-chip>
                      </template>
                    </v-chip-group>
                  </div>
                  <p v-if="categoriesSegment.length == 0 " style="padding-left: 5px;margin-top: 10px;font-size: 13px !important;color: #2F80ED !important; cursor: pointer" @click="handleCreateSegment"> <v-icon size="13" style="color: #2F80ED !important;">mdi-plus</v-icon> Thêm mới</p>
                </div>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu lại</v-btn>
          <v-spacer />

          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import TokenService from "@/helpers/token";
const TypeRepository = RepositoryFactory.get('type');
const ContactRepository = RepositoryFactory.get('contact');
const ContactStatusRepository = RepositoryFactory.get('contact_status');

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    filterForm: {
      default: () => ({})
    },
    // contactStatusList: {
    //   type: Array,
    //   default: () => []
    // },
    contacts: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    contactsSelected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchInput: '',
      segmentCode: "",
      segmentMenu: false,
      segmentId: '',
      showModal: false,
      errorMessage: '',
      statusId: '',
      contactStatusList: [],
      listSegment: [],
    };
  },
  computed: {
    categoriesSegment() {
      const search = this.searchInput
      const dataTemp = {  ...this.listSegment }
      if (!search) return  this.listSegment.length ?  this.listSegment.slice(0, 10) : []
      const dataListSearch = this.listSegment.filter(item => {
        const text = item.segmentCode
        return text.indexOf(search) > -1
      })
      return dataListSearch.length ? dataListSearch.slice(0, 10) : []
    }
    // selectContactStatusList() {
    //   let selectType = this.filterForm.store === 'T' ? ['T0', 'T1', 'T2', 'T3']
    //     : this.filterForm.store === 'C' ? ['C0', 'C1', 'C2', 'C3']
    //     : this.filterForm.store === 'G' ? ['G0', 'G1', 'G2', 'G3'] : ['M0', 'M1', 'M2', 'M3'];
    //   if (this.isStaff() && !this.checkAuthorization('contact_view_all')) {
    //     selectType.shift();
    //   }
    //   const contactStatusList = [];
    //   const checkType = {};
    //   this.contactStatusList.forEach(contactStatus => {
    //     const typeContactStatus = contactStatus.type;
    //     if (selectType.includes(typeContactStatus.slice(-2))) {
    //       if (!checkType[typeContactStatus]) {
    //         checkType[typeContactStatus] = true;
    //         if (contactStatusList.length > 0) {
    //           contactStatusList.push({ divider: true });
    //         }
    //         contactStatusList.push({
    //           header: typeContactStatus.slice(0, typeContactStatus.length - 4),
    //           style: 'color: red;'
    //         });
    //       }
    //       contactStatus.name = `${typeContactStatus.slice(-2)} ${contactStatus.name}`
    //       contactStatusList.push(contactStatus);
    //     }
    //   });
    //   return contactStatusList;
    // }
  },
  created() {
    this.selectContactStatusList();
    this.getListSegmentCode()
  },
  watch: {
    searchInput: {
      deep: true,
      handler(newVal) {
        if(newVal) {
          this.isSearch= true
        }
      }
    },
    segmentId: {
      deep: true,
      handler(newVal) {
        this.searchInput = ''
      }
    },
  },
  methods: {
    handleDeleteSegment() {
      this.segmentId = '';
      this.segmentMenu = true;
    },
    async handleCreateSegment() {
      if(this.categoriesSegment.length == 0) {
        try {
          const params = {
            "obj": "segments",
            "data": {
              "segmentCode": this.searchInput,
              "createdBy": TokenService.getId(),
              "updatedBy": TokenService.getId(),
              "createdName":  TokenService.getFullName(),
            }
          }
          const response = await TypeRepository.createSegmentApi(params)
          if(response.success) {
            this.$swal({
              title: 'Tạo tệp khách hàng thành công',
              icon: 'success',
            })
            this.searchInput = ''
            this.segmentId =  response.data ? response.data?.id : '';
            await this.getListSegmentCode()
          }else {
            this.$swal({
              title: 'Có lỗi xảy ra!',
              icon: 'error',
            })
            this.listSegment = []
          }
        }catch (e) {
          console.log(e)
        }
      }
    },
    async getListSegmentCode() {
      try {
        const params = {
          'sorts[createdAt]':  'desc'
        }
        const response = await TypeRepository.listSegmentCodeApi(params)
        if(response.success) {
          this.listSegment = _.get(response, 'data', [])
        }else {
          this.listSegment = []
        }
      }catch (e) {
        console.log(e)
      }
    },
    hideModal: function() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.modalType = '';
      this.errorMessage = '';
      this.statusId = '';
    },
    async saveChange() {
      let changeContactList = this.contacts.filter(contact => contact.checkbox);
      if (changeContactList.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text:
            'Vui lòng chọn khách hàng và lựa chọn trạng thái cần thay đổi !!!'
        });
      }
      const existT4T5 = changeContactList.filter(contact => !this.checkConditionT4NT5(_.get(contact, 'contactStatus.type', '')));
      changeContactList = changeContactList.filter(contact => contact.statusId != this.statusId)

      if(existT4T5.length > 0) {
        return this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Lỗi !',
          text:
            'Bạn không có quyền chuyển mối quan hệ ở trạng thái T4/T5/C4/C5'
        });
      }

      if (changeContactList.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text:
            'Mối quan hệ hiện tại đang không thay đổi !!!'
        });
      }
      const dataUpdate = changeContactList.map(contact => ({
        contactId: contact.id,
        statusId: this.statusId,
        segmentId: this.segmentId == '' ? 0 : this.segmentId,
      }));
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactStatusV3(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }
      this.$swal({
        title: 'Chuyển mối quan hệ thành công!',
        confirmButtonText: 'Đồng ý'
      }).then(() => {
        this.hideModal();
        Bus.$emit('contact-list-filter', this.filterForm);
        Bus.$emit('contact-status-list');
      });
    },
    async selectContactStatusList() {
      const selectType =
          _.get(this.contactsSelected[0], 'contactStatus.type', 'T').includes('T')
              ? ['T0', 'T1', 'T2', 'T3']
              : _.get(this.contactsSelected[0], 'contactStatus.type', 'C').includes('C') ? ['C0', 'C1', 'C2', 'C3']
              : ['M0', 'M1', 'M2', 'M3', 'M4'];
      if (this.isStaff() && !this.checkAuthorization('contact_view_all')) {
        selectType.shift();
      }

      const contactStatusList = [];
      // const loading = this.$loading.show();
      const response = await ContactStatusRepository.list({
        // store: this.contactsSelected[0].store,
        typeId: this.contactsSelected[0].typeId,
        schoolLevelId: this.contactsSelected[0].schoolLevelId
      });
      // loading.hide();
      if (response.success) {
        const checkType = {};
        _.get(response, 'data', []).forEach(contactStatus => {
          const typeContactStatus = contactStatus.type;
          if (
              selectType.includes(typeContactStatus.slice(-2)) ||
              _.get(contactStatus, 'id', '') == this.contactsSelected[0].statusId
          ) {
            if (!checkType[typeContactStatus]) {
              checkType[typeContactStatus] = true;
              if (contactStatusList.length > 0) {
                contactStatusList.push({divider: true});
              }
              contactStatusList.push({
                header: typeContactStatus.slice(0, typeContactStatus.length - 4),
                style: 'color: red;'
              });
              _.get(contactStatus, 'data', []).forEach(data => {
                data.otherName = `${typeContactStatus.slice(-2)} ${data.name}`
                contactStatusList.push({
                  id: _.get(data, 'id', 0),
                  otherName: _.get(data, 'otherName', ''),
                  type: _.get(data, 'type', ''),
                });
              });
            }
          }
        });
      }
      this.contactStatusList = contactStatusList;
    },
  }
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
</style>
